
import {  useQuery } from "react-query"

import DataService from '../../config/DataServices'

const { getRequest} = DataService()





export const useGetCmsdata = ({fieldtype,language }) => {
  
    return useQuery({
        queryKey: ["get_cmscontent",fieldtype],
        queryFn: () => {
            return getRequest(`/cms?type=${fieldtype}&language=${language}`)
        }
    })
}
